import NetworkLogic from "../../Shared/NetworkLogic";
import UIManager from "../../Shared/UIManager";
const i18n = require('LanguageData');


class TaskData {

    private _mainSwitch = null;
    private _popSwitch = null;

    public recommendData = null;
    private listType = {};

    public recommendTexture = null;
    public taskNum: number = 0;

    constructor() {

    }

    resetData() {
        this._mainSwitch = null;
        this._popSwitch = null;

        this.recommendData = null;
        this.listType = {};
        this.taskNum = 0;
    }

    async getTaskMainSwitch() {
        if (!this._mainSwitch) {
            this._mainSwitch = await this._getTaskMainSwitch();
        }
        return this._mainSwitch;
    }

    async getTaskPopSwitch() {
        if (!this._popSwitch) {
            let rec = await this._getTaskPopSwitch();
            let bOpen = false;
            if (rec.status === "0") {
                bOpen = true;
            }
            this._popSwitch = bOpen;
        }
        return this._popSwitch;
    }




    async getList(index) {
        if (!this.listType[index]) {
            let taskList = await this._getTaskList(index);

            this.listType[index] = taskList;
        }
        return this.listType[index];
    }

    set ListType(value) {
        this.listType = value;
    }

    async getRecommendTask() {
        if (!this.recommendData) {
            this.recommendData = await this._getRecommendTask();
        }
        return this.recommendData;
    }


    loadTexture(value): Promise<any> {
        return new Promise(resolve => {
            cc.loader.load(value, function (err, texture) {
                if (!err) {
                    resolve(texture);
                } else {
                    resolve(err);
                }
            }.bind(this))
        })
    }

    taskGetTypes() {
        return new Promise<any>(resolve => {
            NetworkLogic.taskGetTypes({}, function (rec) {
                cc.log("====_getTaskList:", rec);
                resolve(rec)
            }.bind(this), function () {
                resolve(null);
            }.bind(this))
        })
    }

    _getTaskList(index): Promise<any> {
        cc.log("====进_getTaskList");
        UIManager.showLoadingUI();
        return new Promise<any>(resolve => {
            NetworkLogic.taskList({ "taskTypeId": index }, function (rec) {
                UIManager.hideLoadingUI();
                cc.log("====_getTaskList:", rec);
                resolve(rec)
            }.bind(this), function () {
                resolve([]);
            }.bind(this))
        })
    }

    _getTaskPopSwitch(): Promise<any> {
        return new Promise<any>(resolve => {
            NetworkLogic.taskSwitch({}, "pop", function (rec) {
                cc.log("====任务副开关rec：", rec);
                resolve(rec);
            }.bind(this), function () {
                resolve(false);
            }.bind(this))
        })
    }


    _getTaskMainSwitch() {
        return new Promise<any>(resolve => {
            NetworkLogic.taskSwitch({}, "main", function (rec) {
                cc.log("====任务总开关rec：", rec);
                UIManager.hideLoadingUI();
                let bOpen = false;
                if (rec.status === "0") {
                    bOpen = true;
                }
                resolve(bOpen);
            }.bind(this), function () {
                UIManager.hideLoadingUI();
                resolve(false);
            }.bind(this))
        })
    }

    _getRecommendTask(): Promise<any> {
        return new Promise<any>(resolve => {
            NetworkLogic.taskRecommend({}, function (rec) {
                cc.log("=====getRecommendTask rec", rec);
                resolve(rec);
            }.bind(this), function () {
                cc.log("=====rec");
                resolve(null);
            }.bind(this))
        })
    }


    getBtnType(type) {//taskHandleStatus 状态 -1：未完成 0:申请中 1：已发放 2：已拒绝 3:可领取 4：可申请
        let str = ""
        switch (type) {
            case -1:
                str = i18n.t('Task.complete');
                break;
            case 0:
                str = i18n.t('Task.application');
                break;
            case 1:
                str = i18n.t('msg_text.receive');
                break;
            case 2:
                str = i18n.t('Task.refused');
                break;
            case 3:
                str = i18n.t('XimaLayer.receive');
                break;
            case 4:
                str = i18n.t('Task.apply_reward');
                break;
        }
        return str;
    }

    getBtnType1(type) {//taskHandleStatus 状态 -1：未完成 0:申请中 1：已发放 2：已拒绝 3:可领取 4：可申请
        let str = ""
        switch (type) {
            case -1:
                str = i18n.t('share_text.submit_audit');
                break;
            case 0:
                str = i18n.t('Task.application');
                break;
            case 1:
                str = i18n.t('msg_text.receive');
                break;
            case 2:
                str = i18n.t('Task.refused');
                break;
            case 3:
                str = i18n.t('XimaLayer.receive');
                break;
            case 4:
                str = i18n.t('share_text.apply_reward');
                break;
        }
        return str;
    }

    getStateStr(type) {//taskHandleStatus 状态 -1：未完成 0:申请中 1：已发放 2：已拒绝 3:可领取 4：可申请
        let str = ""
        switch (type) {
            case -1:

                str = i18n.t('Task,submit_creenshot');
                break;
            case 0:
                str = i18n.t('pre_details_text.audit');
                break;
            case 1:
                str = i18n.t('msg_text.receive');
                break;
            case 2:
                str = i18n.t('Task.Audit_failure');
                break;
            case 3:
                str = i18n.t('XimaLayer.receive');;
                break;
            case 4:
                str = i18n.t('share_text.apply_reward');
                break;
        }
        return str;
    }

    getBtnInteractable(type) {//taskHandleStatus 状态 -1：未完成 0:申请中 1：已发放 2：已拒绝 3:可领取 4：可申请
        let bActive = true;
        switch (type) {
            case -1:
                bActive = true;
                break;
            case 0:
                bActive = false;
                break;
            case 1:
                bActive = false;
                break;
            case 2:
                bActive = false;
                break;
            case 3:
                bActive = true;
                break;
            case 4:
                bActive = true;
                break;
        }
        return bActive;
    }




}
export default new TaskData
